export function initBlogToc() {
    const article = document.querySelector('.blog-post')
    if (!article) return

    const headings = article.querySelectorAll('h2, h3')
    if (headings.length < 3) return

    const items = []
    headings.forEach((h, i) => {
        if (!h.id) h.id = 'section-' + (i + 1)
        items.push({ id: h.id, text: h.textContent.trim(), level: h.tagName.toLowerCase() })
    })

    // --- Grid layout ---
    const wrapper = document.getElementById('blogContent')
    const main = document.getElementById('blogMain')
    wrapper.classList.remove('max-w-4xl', 'lg:max-w-5xl')
    wrapper.classList.add('lg:max-w-5xl', 'lg:grid', 'lg:grid-cols-12', 'lg:gap-12')
    main.classList.add('lg:col-span-8')

    let mobileBody, mobileChevron, mobileBtn

    // --- Іконка списку (TOC) ---
    const tocIcon = '<svg class="w-4 h-4 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/></svg>'

    // --- Побудова посилань ---
    function buildTocLinks(container, variant) {
        items.forEach(item => {
            const li = document.createElement('li')
            const a = document.createElement('a')
            a.href = '#' + item.id
            a.textContent = item.text
            a.dataset.tocId = item.id

            if (variant === 'desktop') {
                a.className = [
                    'block px-3 py-2 rounded-lg text-sm leading-snug',
                    'text-on-surface-variant',
                    'hover:bg-on-surface/8 hover:text-on-surface',
                    'transition-colors duration-200',
                    'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary',
                    item.level === 'h3' ? 'ml-3 text-xs' : ''
                ].join(' ')
            } else {
                a.className = [
                    'block px-3 py-1.5 rounded-lg text-sm leading-snug',
                    'text-on-surface-variant',
                    'hover:bg-on-surface/8 hover:text-on-surface',
                    'transition-colors duration-200',
                    'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary',
                    item.level === 'h3' ? 'ml-3 text-xs' : ''
                ].join(' ')
            }

            a.addEventListener('click', (e) => {
                e.preventDefault()
                const target = document.getElementById(item.id)
                if (target) {
                    target.scrollIntoView({ behavior: 'smooth', block: 'start' })
                    setActive(item.id)
                }
                if (mobileBody) closeMobile()
            })

            li.appendChild(a)
            container.appendChild(li)
        })
    }

    // --- Desktop sidebar (MD3 Outlined Card, collapsible) ---
    const aside = document.createElement('aside')
    aside.className = 'hidden lg:block lg:col-span-4'

    const sticky = document.createElement('div')
    sticky.className = 'sticky top-24 max-h-[calc(100vh-8rem)] overflow-y-auto'

    const card = document.createElement('div')
    card.className = 'bg-surface-container-low border border-outline rounded-xl'

    const nav = document.createElement('nav')
    nav.setAttribute('aria-label', 'Зміст статті')

    const desktopToggle = document.createElement('button')
    desktopToggle.type = 'button'
    desktopToggle.setAttribute('aria-expanded', 'true')
    desktopToggle.className = [
        'w-full flex items-center justify-between gap-2 px-4 py-3',
        'text-sm font-medium text-on-surface rounded-xl',
        'hover:bg-on-surface/8',
        'transition-colors duration-200'
    ].join(' ')
    desktopToggle.innerHTML = `
        <span class="flex items-center gap-2">
            <span class="text-on-surface-variant">${tocIcon}</span>
            Зміст
        </span>
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
             fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
             class="text-on-surface-variant flex-shrink-0 motion-safe:transition-transform motion-safe:duration-200 rotate-180">
            <polyline points="6 9 12 15 18 9"/>
        </svg>`
    const desktopChevron = desktopToggle.querySelector('svg:last-child')

    const desktopBody = document.createElement('div')
    desktopBody.className = 'border-t border-outline p-2'

    const desktopList = document.createElement('ul')
    desktopList.className = 'space-y-0.5'
    buildTocLinks(desktopList, 'desktop')
    desktopBody.appendChild(desktopList)

    desktopToggle.addEventListener('click', () => {
        const isOpen = desktopToggle.getAttribute('aria-expanded') === 'true'
        desktopToggle.setAttribute('aria-expanded', String(!isOpen))
        desktopBody.hidden = isOpen
        desktopChevron.classList.toggle('rotate-180', !isOpen)
    })

    nav.appendChild(desktopToggle)
    nav.appendChild(desktopBody)
    card.appendChild(nav)
    sticky.appendChild(card)
    aside.appendChild(sticky)
    wrapper.appendChild(aside)

    // --- Mobile TOC (MD3 Card + Expansion) ---
    const mobileTocSlot = document.getElementById('mobileToc')
    const mobileWrap = document.createElement('div')
    mobileWrap.className = 'lg:hidden bg-surface-container-low border border-outline rounded-xl mb-8 overflow-hidden'

    mobileBtn = document.createElement('button')
    mobileBtn.type = 'button'
    mobileBtn.setAttribute('aria-expanded', 'false')
    mobileBtn.className = [
        'w-full flex items-center justify-between gap-2 px-4 py-3',
        'text-sm font-medium text-on-surface',
        'hover:bg-on-surface/8',
        'transition-colors duration-200'
    ].join(' ')
    mobileBtn.innerHTML = `
        <span class="flex items-center gap-2">
            <span class="text-on-surface-variant">${tocIcon}</span>
            Зміст статті
        </span>
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
             fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
             class="text-on-surface-variant flex-shrink-0 motion-safe:transition-transform motion-safe:duration-200">
            <polyline points="6 9 12 15 18 9"/>
        </svg>`
    mobileChevron = mobileBtn.querySelector('svg:last-child')

    mobileBody = document.createElement('div')
    mobileBody.className = 'border-t border-outline'
    mobileBody.hidden = true

    const mobileNav = document.createElement('nav')
    mobileNav.setAttribute('aria-label', 'Зміст статті')
    mobileNav.className = 'p-2'
    const mobileList = document.createElement('ul')
    mobileList.className = 'space-y-0.5'
    buildTocLinks(mobileList, 'mobile')
    mobileNav.appendChild(mobileList)
    mobileBody.appendChild(mobileNav)

    function closeMobile() {
        mobileBody.hidden = true
        mobileBtn.setAttribute('aria-expanded', 'false')
        mobileChevron.classList.remove('rotate-180')
    }

    mobileBtn.addEventListener('click', () => {
        const opening = mobileBody.hidden
        mobileBody.hidden = !opening
        mobileBtn.setAttribute('aria-expanded', String(opening))
        mobileChevron.classList.toggle('rotate-180', opening)
    })

    mobileWrap.appendChild(mobileBtn)
    mobileWrap.appendChild(mobileBody)
    mobileTocSlot.appendChild(mobileWrap)

    // --- Scroll spy ---
    let activeId = ''
    const allLinks = wrapper.querySelectorAll('[data-toc-id]')

    function setActive(id) {
        if (id === activeId) return
        activeId = id
        allLinks.forEach(a => {
            const isActive = a.dataset.tocId === id

            // Скидаємо стан
            a.classList.remove(
                'bg-primary/8', 'text-primary', 'font-medium',
                'text-on-surface-variant'
            )

            if (isActive) {
                a.classList.add('bg-primary/8', 'text-primary', 'font-medium')
            } else {
                a.classList.add('text-on-surface-variant')
            }
        })
    }

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) setActive(entry.target.id)
        })
    }, {
        rootMargin: '-96px 0px -60% 0px',
        threshold: 0
    })

    items.forEach(item => {
        const el = document.getElementById(item.id)
        if (el) observer.observe(el)
    })
}
